var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"user-wrap"},[_vm._m(0),_c('div',{staticClass:"right"},[_c('div',{staticClass:"right-content"},[_c('router-view')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left"},[_c('img',{attrs:{"src":require("./logo_icon.svg"),"alt":"","srcset":""}})])
}]

export { render, staticRenderFns }